
<div class="api-customers-view">
  <page-header title="API Customers" />

  <section v-if="loaded">
    <empty-state
      v-if="customers.length === 0"
      icon="vpn_key"
      title="No API customers found"
    />

    <template v-else>
      <text-input
        v-model="query"
        class="filter"
        type="search"
        placeholder="Filter by name"
        remove-margin
      />

      <p class="volume-note">
        <template v-if="volumeUpdatedAt">
          Calls in the last 24 hours, cached for up to an hour. Updated {{ $filters.datetime(volumeUpdatedAt) }}.
        </template>
        <template v-else>
          Last 24 hours of call volume is unavailable.
        </template>
      </p>

      <p v-if="filteredCustomers.length === 0" class="no-matches">
        No customers match that name.
      </p>

      <div v-else class="list">
        <div class="list-header">
          <span>Customer</span>
          <span>24h calls</span>
        </div>

        <router-link
          v-for="customer in filteredCustomers"
          :key="customer.uid"
          class="customer-row"
          :to="`/api-customers/${customer.uid}`"
        >
          <span class="name">{{ customer.displayName }}</span>
          <span class="calls">{{ formatCalls(customer.calls24h) }}</span>
        </router-link>
      </div>
    </template>
  </section>

  <spinner v-else />
</div>
